"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBExploreAPI", {
  enumerable: true,
  get: function get() {
    return _SVBExploreAPI.default;
  }
});
var _SVBExploreAPI = _interopRequireDefault(require("./src/SVBExploreAPI"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }